import { z } from "zod";

export const AuditLogRow = z.object({
  id: z.union([z.number(), z.bigint(), z.string()]),
  org_id: z.string().uuid(),
  actor_id: z.string().uuid().nullable(),
  table_name: z.string(),
  row_id: z.string(),
  op: z.enum(["INSERT", "UPDATE", "DELETE"]),
  before: z.unknown().nullable(),
  after: z.unknown().nullable(),
  context: z.unknown().nullable(),
  created_at: z.string(),
});
export type AuditLogRow = z.infer<typeof AuditLogRow>;

export const AuditLogQuery = z.object({
  table_name: z.string().optional(),
  row_id: z.string().optional(),
  actor_id: z.string().uuid().optional(),
  since: z.string().datetime().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type AuditLogQuery = z.infer<typeof AuditLogQuery>;
